<template>
   <div
      id="jumbotron"
      class="jumbotron frontpage-jumbotron rounded-0 position-relative">
      <div
         id="material-wrap"
         v-touch:tap="void 0"
         class="container-fluid container-lg">
         <div
            id="frontFormular"
            class="row">
            <div
               id="main-product-grid"
               class="col-lg-7 position-relative mb-4"
               :class="{ 'xs': breakpoint === 'xs', 'mt-md': small }">
               <div
                  class="my-5"
                  :class="{ 'text-center': true }">
                  <slot>
                     <h1>Få 3 gratis tilbud og find en billig bilforsikring.</h1>
                  </slot>
                  <h2 class="font-weight-normal">Vores brugere sparer gennemsnitsligt 2.700 kr. om året</h2>
               </div>
               <div class="plate-wrapper mt-xl-7 mt-lg-5 mb-xxl-8 mb-3">
                  <material-input
                     v-model="plate"
                     label="Nummerplade"
                     name="plate"
                     @keyup.enter.stop="onEnter($event)"
                     :input-style="{
                        textTransform: 'uppercase',
                        fontFamily: 'Lato, sans-serif',
                        fontWeight: 'bold',
                        fontSize: '150%',
                        color: '#666',
                        maxWidth: '220px',
                     }">
                     <template v-slot:prepend>
                        <div class="plate-prepend fill" />
                     </template>
                  </material-input>
                  <a
                     :href="submitPlateUrl"
                     class="btn btn-secondary btn-lg mt-4">
                     Indhent tilbud
                  </a>
                  <a
                     :href="submitPlateUrl"
                     class="continue-without-plate mt-lg-6 mt-4"
                     @click="plate = ''">
                     Fortsæt uden nummerplade
                  </a>
               </div>
            </div>
            <div class="col-lg-5 font-non-codensed px-lg-0">
               <div class="d-flex h-100 w-100 align-items-end justify-content-center">
                  <picture>
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/woman-car.avif"
                        type="image/avif" />
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/woman-car.webp"
                        type="image/webp" />
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/woman-car.png"
                        type="image/png" />
                     <img
                        class="img-fluid align-self-center"
                        src="/wp-content/themes/findforsikring_2015-sommer/2022/images/woman-car.png"
                        alt="Brugere" />
                  </picture>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import SubmitProductsButton from '@components/SubmitProductsButton';
import ProductsGrid from '@components/ProductsGrid';
import WistiaPlayer from '@components/WistiaPlayer';
import { mapGetters } from 'vuex';
import MaterialInput from '@components/Form/MaterialInput.vue';

export default {
   name: 'AltCarFormNew',
   components: {
      MaterialInput,
      WistiaPlayer,
      ProductsGrid,
      SubmitProductsButton,
   },
   props: {
      custom: {
         type: Object,
         default: function () {
            return {};
         },
      },
   },
   data() {
      return {
         plate: '',
      };
   },
   computed: {
      ...mapGetters(['breakpoint', 'header', 'containerClass', 'width', 'small']),
      containerClasses() {
         return `${this.containerClass} ${this.breakpoint}`;
      },
      headline() {
         return this.$store.getters.headline;
      },
      landingpage() {
         return this.$store.state.landingpage;
      },
      subtitle() {
         return this.landingpage && this.landingpage.subtitle ? this.landingpage.subtitle : null;
      },
      submitPlateUrl() {
         let url = this.$store.getters.formUrl;
         const plate = this.plate.replace(/\s/, '').toLocaleUpperCase();
         if (plate !== '') {
            url += `&nrplade=${plate}`;
         }
         return url;
      },
   },
   methods: {
      resetPlate() {
         this.plate = '';
      },
      onEnter(e) {
         document.location.href = this.submitPlateUrl;
      },
   },
};
</script>

<style lang="scss" scoped>
.plate-wrapper {
   display: flex;
   flex-flow: column wrap;
   justify-content: center;
   align-items: center;

   > * {
      //flex-grow: 1;
      //height: 3em;
      //min-height: 40px;
      //margin: 0.2em;
      //max-width: 80vw;
   }

   .plate-prepend {
      width: 30px;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url(/wp-content/themes/findforsikring_2015-sommer/icons/rasmus-ikoner/eu-license-plate.png);
   }
}

a.continue-without-plate {
   //color: #fff;
   color: var(--ff-dark-blue);
   font-size: 130% !important;
   font-weight: 600;
   //font-weight: lighter;
   //font-family: 'Lato', sans-serif;
   //text-shadow: 2px 3px 2px rgba(0, 0, 0, 0.6);
   text-decoration: none;

   &:hover {
      text-decoration: underline;
   }
}

#jumbotron {
   background-color: var(--ff-stripe-bg);
}

#frontFormular {
   padding-top: unset !important;
}

.extra-space {
   height: 2em;
}

.skilt {
   background-size: contain !important;
   height: 39px;
   top: -25px;
   color: var(--ff-blue);
   position: absolute;
   width: 124px;
   z-index: 500;
   background: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/forside-skilt.png) no-repeat left top
      transparent;
}

#material-wrap {
   font-size: 14px;

   .spacer {
      height: 75px;

      &.xs {
         height: 0;
      }
   }

   &.md {
      font-size: 14px;
   }

   &.sm {
      font-size: 12px;
   }

   &.xs {
      font-size: 10px;

      .extra-space {
         height: 0;
      }

      .spacer.top {
         height: 3em;
      }
   }

   &.md,
   &.lg {
      //.col-md-6 {
      //    padding: 0 !important;
      //}
   }

   .header-spacing {
      height: 0;
      transition: height 0.3s;

      &.active {
         height: 50px;
      }
   }

   h1 {
      //font-size: 270%;
      font-weight: 800;
      font-stretch: 100%;
      margin-top: 0;
   }

   h2 {
      font-size: 170%;
   }

   .col-md-6 {
      //padding: 0 !important;

      //&.xs {
      //    margin: 0 15px;
      //}
   }

   .super-header {
      text-align: center;
      font-size: 120%;
      position: absolute;
      top: -30px;
      left: calc(50% - 3.9em);
   }

   #more-wrap {
      width: 160px;
      margin: 10px auto;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      border-radius: 3px;
      position: relative;

      .more-button {
         //font-family: 'Amaranth', sans-serif;
         font-size: 18px;
      }
   }

   .cell {
      width: 170px;
      margin: 0 auto;
      height: 50px;
   }
}
</style>
